import { Fragment } from 'react';

import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { getField } from 'src/common/helper';
import PatientIcons from '../common/patients/PatientIcons';
import ItemInfo from './ItemInfo';

type PatientInfoType = {
  patient: any;
  dataCounseling: any;
  isLoading: boolean;
};

const PatientInfo: React.FC<PatientInfoType> = (props) => {
  return (
    <>
      <Stack direction={'row'} spacing={'16px'} my={'16px'}>
        <Box
          component={'img'}
          src='/images/icons/draw/ic-gender-women.svg'
          alt='ic-note'
          width={'32px'}
        />
        <Stack>{props.isLoading ? (
          <>
            <Skeleton width={'100px'} height={'20px'} />
            <Skeleton width={'100px'} height={'20px'} />
          </>
        ) : (
          <>
            <Typography fontWeight={500} color={'#656D78'}>
              {getField(props.patient, 'kana', '-')}
            </Typography>
            <Typography fontSize={'20px'} fontWeight={500} color={'#434154'}>
              {getField(props.patient, 'fullname', '-')}
            </Typography>
          </>
        )}
        </Stack>
      </Stack>

      {props.isLoading ? (
        <Skeleton width={'240px'} height={'40px'} />
      ) : (
        <PatientIcons patient={props.patient}/>
      )}

      <ItemInfo label='患者ID' content={getField(props.patient, 'patientno', '-')} isLoading={props.isLoading} />

      <ItemInfo label='ケース' content={getField(props.dataCounseling, 'case', '-')} isLoading={props.isLoading} />

      <ItemInfo label='担当者' content={getField(props.dataCounseling, 'person', '-')} isLoading={props.isLoading} />

      <ItemInfo label='実施日' content={getField(props.dataCounseling, 'date', '-')} isLoading={props.isLoading} />

      <ItemInfo label='電話' content={getField(props.patient, 'phone', '-')} isLoading={props.isLoading} />

      <ItemInfo label='メールアドレス' content={getField(props.patient, 'email', '-')} isLoading={props.isLoading} />

      {props.isLoading ? (
        <ItemInfo label='備考' content={''} isLoading={props.isLoading} />
      ) : (
        props.patient &&
        Array.isArray(props.patient.notes) &&
        props.patient.notes.map((note: any, index: number) => {
          if (note.label !== '備考') return <Fragment key={index}></Fragment>;
          return (
            <Stack mb={'10px'} key={index}>
              <Typography color={'#00000080'}>
                {note.label}
              </Typography>
              {Array.isArray(note.items) &&
                note.items.map((item: any, idx: number) => {
                  return (
                    <Typography
                      key={idx}
                      fontSize={'14px'}
                      fontWeight={500}
                      color={'#484848'}
                    >
                      {getField(item, 'value', '-')}
                    </Typography>
                  );
                })}
            </Stack>
          );
        })
      )}
    </>
  );
};

export default PatientInfo;
